import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { DateUtil } from '../../ui/DateUtil';

@Component({
  selector: 'app-form-datetime-field',
  templateUrl: './form-datetime-field.component.html',
  styleUrl: './form-datetime-field.component.scss'
})
export class FormDateTimeFieldComponent extends FieldType {
  value = "";
  ngOnInit(): void {
    this.value = DateUtil.getDateTimeFormat(this.formControl.value);
  }
}
